import React from "react";
import { Controller as Fc } from "react-hook-form";
import TreffasTextField from "src/components/TreffasTextField";
import TreffasStyle from "src/utils/TreffasStyle";
import { TextField } from "@mui/material";

const QuestionEssayAnswer = ({ control, item, errors, themes }) => {
  // If no control provided, use native form input
  if (!control) {
    return (
      <TextField
        fullWidth
        multiline
        minRows={3}
        sx={TreffasStyle.formInput(themes)}
        name={`answer[${item.id}][${item.choices[0].id}][]`}
        required={Boolean(item.is_required)}
      />
    );
  }

  // Use react-hook-form when control is provided
  return (
    <Fc
      name={`answer[_${item.id}][_${item.choices[0].id}]`}
      control={control}
      render={({ field }) => (
        <TreffasTextField
          {...field}
          value={field.value ?? ""}
          fullWidth
          multiline
          minRows={3}
          sx={TreffasStyle.formInputLarge("textarea")}
          error={Boolean(
            errors["answer"]?.[`_${item.id}`]?.[`_${item.choices[0].id}`]
              ?.required
          )}
          helperText={
            errors["answer"]?.[`_${item.id}`]?.[`_${item.choices[0].id}`]
              ?.message
          }
        />
      )}
    />
  );
};

export default QuestionEssayAnswer;
